import type { InventoryItem, ContainerCapacity, SlotSection } from "./types";
import item1 from "./assets/images/items/1.png";
import item2 from "./assets/images/items/2.png";
import item3 from "./assets/images/items/3.png";

const ITEM_IMAGES = [item1, item2, item3];
const img = (i: number) => ITEM_IMAGES[i % ITEM_IMAGES.length];

export const ALL_ITEMS: InventoryItem[] = [
  {
    id: "1",
    name: "Pistol",
    description:
      "Standard semi-automatic pistol. Reliable in close-range engagements.",
    weight: 1.5,
    quantity: 1,
    image: img(0),
    type: "weapon",
  },
  {
    id: "2",
    name: "Ammo Box",
    description: "Box of 9mm rounds. Always keep your magazine loaded.",
    weight: 0.5,
    quantity: 50,
    image: img(1),
    type: "weapon",
  },
  {
    id: "3",
    name: "First Aid Kit",
    description: "Basic medical supplies for treating wounds in the field.",
    weight: 1.2,
    quantity: 3,
    image: img(2),
    type: "consumable",
  },
  {
    id: "4",
    name: "Jerry Can",
    description: "Heavy-duty canister for storing vehicle fuel.",
    weight: 3.0,
    quantity: 1,
    image: img(3),
    type: "tool",
  },
  {
    id: "5",
    name: "Water Bottle",
    description: "Keeps you hydrated during long operations.",
    weight: 0.3,
    quantity: 12,
    image: img(4),
    type: "food",
  },
  {
    id: "6",
    name: "Car Tire",
    description: "Standard replacement tire for most road vehicles.",
    weight: 8.0,
    quantity: 2,
    image: img(5),
    type: "tool",
  },
  {
    id: "7",
    name: "Rifle",
    description:
      "Semi-automatic long-range rifle. Effective at medium to long distances.",
    weight: 4.5,
    quantity: 1,
    image: img(0),
    type: "weapon",
  },
  {
    id: "8",
    name: "Bandages",
    description: "Stops bleeding and stabilizes minor wounds quickly.",
    weight: 0.2,
    quantity: 8,
    image: img(1),
    type: "consumable",
  },
  {
    id: "9",
    name: "Energy Drink",
    description: "Boosts stamina and restores a small amount of health.",
    weight: 0.3,
    quantity: 4,
    image: img(2),
    type: "food",
  },
  {
    id: "10",
    name: "Cash Bundle",
    description:
      "A stack of unmarked bills. Accepted everywhere, no questions asked.",
    weight: 0.1,
    quantity: 5000,
    image: img(3),
    type: "misc",
  },
  {
    id: "11",
    name: "Sneakers",
    description: "Lightweight running shoes. Good for long distances.",
    weight: 0.8,
    quantity: 1,
    image: img(4),
    type: "clothing",
    equipmentType: "shoes",
  },
  {
    id: "12",
    name: "Dice Set",
    description: "A pair of lucky dice. Suspiciously weighted.",
    weight: 0.1,
    quantity: 2,
    image: img(5),
    type: "misc",
  },
  {
    id: "13",
    name: "Angle Grinder",
    description: "Cuts through metal, chains, and padlocks with ease.",
    weight: 2.5,
    quantity: 1,
    image: img(0),
    type: "tool",
  },
  {
    id: "14",
    name: "Burger",
    description: "A juicy double burger. Restores hunger moderately.",
    weight: 0.4,
    quantity: 1,
    image: img(1),
    type: "food",
  },
  {
    id: "15",
    name: "Backpack",
    description:
      "Purple canvas backpack. Increases your carry capacity significantly.",
    weight: 1.0,
    quantity: 1,
    image: img(2),
    type: "misc",
  },
  {
    id: "16",
    name: "Cigarettes",
    description: "A pack of cigarettes. Slightly reduces stress.",
    weight: 0.1,
    quantity: 12,
    image: img(3),
    type: "consumable",
  },
  {
    id: "17",
    name: "Rope",
    description: "Heavy-duty orange rope. Useful for restraints and climbing.",
    weight: 1.5,
    quantity: 1,
    image: img(4),
    type: "tool",
  },
  {
    id: "18",
    name: "Cap",
    description: "Casual streetwear cap.",
    weight: 0.2,
    quantity: 1,
    type: "clothing",
    equipmentType: "hat",
  },
  {
    id: "19",
    name: "Sunglasses",
    description: "Classic aviator shades.",
    weight: 0.1,
    quantity: 1,
    type: "clothing",
    equipmentType: "glasses",
  },
  {
    id: "20",
    name: "Ski Mask",
    description: "Full-face balaclava.",
    weight: 0.2,
    quantity: 1,
    type: "clothing",
    equipmentType: "mask",
  },
  {
    id: "21",
    name: "Leather Jacket",
    description: "Heavy-duty biker jacket.",
    weight: 1.5,
    quantity: 1,
    type: "clothing",
    equipmentType: "jacket",
  },
  {
    id: "22",
    name: "Silk Tie",
    description: "Makes you look important.",
    weight: 0.1,
    quantity: 1,
    type: "clothing",
    equipmentType: "tie",
  },
  {
    id: "23",
    name: "T-Shirt",
    description: "Plain white cotton tee.",
    weight: 0.3,
    quantity: 1,
    type: "clothing",
    equipmentType: "torso",
  },
  {
    id: "24",
    name: "Cargo Pants",
    description: "Durable pants with many pockets.",
    weight: 0.6,
    quantity: 1,
    type: "clothing",
    equipmentType: "pants",
  },
  {
    id: "25",
    name: "Gloves",
    description: "Tactical gloves. Leave no prints.",
    weight: 0.2,
    quantity: 1,
    type: "clothing",
    equipmentType: "gloves",
  },
  {
    id: "26",
    name: "Vest",
    description: "Lightweight bulletproof vest.",
    weight: 3.0,
    quantity: 1,
    type: "clothing",
    equipmentType: "armor",
  },
  {
    id: "27",
    name: "Gold Chain",
    description: "Heavy 24k gold chain.",
    weight: 0.3,
    quantity: 1,
    type: "clothing",
    equipmentType: "necklace",
  },
  {
    id: "28",
    name: "Watch",
    description: "Luxury Swiss timepiece.",
    weight: 0.2,
    quantity: 1,
    type: "clothing",
    equipmentType: "watch",
  },
  {
    id: "29",
    name: "Phone",
    description: "Burner smartphone.",
    weight: 0.2,
    quantity: 1,
    type: "clothing",
    equipmentType: "phone",
  },
  {
    id: "30",
    name: "Small Bag",
    description: "Compact shoulder bag.",
    weight: 0.5,
    quantity: 1,
    type: "clothing",
    equipmentType: "bag",
  },
  {
    id: "31",
    name: "Duffel Bag",
    description: "Large capacity duffel.",
    weight: 1.2,
    quantity: 1,
    type: "clothing",
    equipmentType: "bag",
  },
];

// Items near the player on the ground — weapons & consumables
export const NEARBY_ITEMS: (InventoryItem | null)[] = [
  ALL_ITEMS[0],
  ALL_ITEMS[1],
  ALL_ITEMS[2],
  ALL_ITEMS[4],
  ALL_ITEMS[8],
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
];

// Car trunk — tools & heavy gear
export const CAR_TRUNK_ITEMS: (InventoryItem | null)[] = [
  ALL_ITEMS[3],
  ALL_ITEMS[5],
  ALL_ITEMS[6],
  ALL_ITEMS[16],
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
];

// Player inventory — everyday items + clothing
export const INVENTORY_ITEMS: (InventoryItem | null)[] = [
  ALL_ITEMS[7],
  ALL_ITEMS[9],
  ALL_ITEMS[10],
  ALL_ITEMS[11],
  ALL_ITEMS[12],
  ALL_ITEMS[17],
  ALL_ITEMS[18],
  ALL_ITEMS[19],
  ALL_ITEMS[20],
  ALL_ITEMS[21],
  ALL_ITEMS[22],
  ALL_ITEMS[23],
  ALL_ITEMS[24],
  ALL_ITEMS[25],
  ALL_ITEMS[26],
];

// Backpack — misc, cash, bags, accessories
export const BACKPACK_ITEMS: (InventoryItem | null)[] = [
  ALL_ITEMS[13],
  ALL_ITEMS[14],
  ALL_ITEMS[15],
  ALL_ITEMS[27],
  ALL_ITEMS[28],
  ALL_ITEMS[29],
  ALL_ITEMS[30],
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
];

export const FAST_ITEMS: (InventoryItem | null)[] = Array(10).fill(null);

export const CAPACITIES: Record<SlotSection, ContainerCapacity> = {
  nearby: { maxSlots: 15, usableSlots: 13 },
  carTrunk: { maxSlots: 15, usableSlots: 15 },
  inventory: { maxSlots: 15, usableSlots: 15 },
  backpack: { maxSlots: 15, usableSlots: 10 },
  fastItems: { maxSlots: 10, usableSlots: 10 },
};

export const CAR_PLATE = "XZC 987";

export const PLAYER = {
  name: "Romario Richardson",
  money: 12750,
  weight: { current: 65.4, max: 90 },
};
